export const CREATE_EXPENSE_GROUP_TYPE_MAP = 'CREATE_EXPENSE_GROUP_TYPE_MAP';
export const EDIT_EXPENSE_GROUP_TYPE_MAP = 'EDIT_EXPENSE_GROUP_TYPE_MAP';
export const SHOW_EXPENSE_GROUP_TYPE_MAP = 'SHOW_EXPENSE_GROUP_TYPE_MAP';
export const EXPENSE_GROUP_TYPE_MAP_SUCCESS = 'EXPENSE_GROUP_TYPE_MAP_SUCCESS';
export const EXPENSE_GROUP_TYPE_MAP_ERROR = 'EXPENSE_GROUP_TYPE_MAP_ERROR';

